/**
 * en-CA is NOT a timezone. It is only a date formatting locale.
It does not apply Canadian time rules.
It does not convert the date.
It does not shift the day.
It does not override your NZ timezone.
 * @param year  
 * @param month 
 * @returns 
 */
export const getLastDayOfMonth = (year: number, month: number): string => {
  const date = new Date(year, month + 1, 0); // correct last-day logic
  return date.toLocaleDateString("en-CA"); // stays in NZ local time
};

export const buildMonthOptions = (year: number) => {
  const formatter = new Intl.DateTimeFormat("en-NZ", { month: "short" });

  return Array.from({ length: 12 }, (_, month) => {
    const label = `${formatter.format(new Date(year, month))}-${String(year).slice(2)}`;
    const value = getLastDayOfMonth(year, month); // e.g., "2026-01-31"

    return { label, value };
  });
};
export const buildYearOptions = () => {
  const currentYear = new Date().getFullYear();
  const lastYear = currentYear - 1;

  return [
    {
      label: `${currentYear}`,
      value: getLastDayOfYear(currentYear),
    },
    {
      label: `${lastYear}`,
      value: getLastDayOfYear(lastYear),
    },
  ];
};
function getLastDayOfYear(year: number): string {
  return `${year}-12-31`;
}
